/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Header() {
  return (
    <header id="header" className="fixed-top">
    <div className="container d-flex align-items-center">

      <h1 className="logo mr-auto" style={{color: "blue"}}><a href="/">ARA Learning Academy</a></h1>
      {/* <!-- Uncomment below if you prefer to use an image logo --> */}
      {/* <a href="/" className="logo mr-auto"><img src="assets/img/logo.png" alt="" className="img-fluid"/></a> */}

      <nav className="nav-menu d-none d-lg-block">
        <ul>
          <li className="active"><a href="/">Home</a></li>
          <li><a href="/news">News & update
          {/* <span className="span_badge">coming soon</span> */}
          </a></li>
          <li><a href="/about">About</a></li>
          <li><a href="/courses">Courses</a></li>
          <li className="drop-down"><a>Faculty</a>
            <ul>
            <li><a href="/trainer">Trainers</a></li>
            <li><a href="/advisor">Advisors</a></li>
            </ul>
          </li>

        </ul>
      </nav>
      {/* <!-- .nav-menu --> */}

      <a href="/login" className="get-started-btn">Login</a>

    </div>
  </header>
  );
} 